<template>
  <div class="home">
    <div class="bannerList">
      <el-carousel
        :height="bannerListHeight"
        :loop="true"
        :autoplay="true"
        arrow="never"
        interval="7000"
      >
        <el-carousel-item v-if="isMobile == 0">
          <video autoplay loop muted>
            <source
              src="https://nanchangfile.oss-cn-beijing.aliyuncs.com/1-1-1.mp4"
              type="video/mp4"
            />
          </video>
        </el-carousel-item>
        <el-carousel-item v-if="isMobile == 0">
          <video autoplay loop muted>
            <source
              src="https://nanchangfile.oss-cn-beijing.aliyuncs.com/2-2-2.mp4"
              type="video/mp4"
            />
          </video>
        </el-carousel-item>
        <el-carousel-item v-if="isMobile == 0">
          <video autoplay loop muted>
            <source
              src="https://nanchangfile.oss-cn-beijing.aliyuncs.com/3-3-3.mp4"
              type="video/mp4"
            />
          </video>
        </el-carousel-item>
      </el-carousel>
      <div class="bannerList_title">
        从沉浸空间到虚实交互，从软件开发到文旅新生<br /><br />让新媒体融入科技<br />激活数字体验新纪元<br />
      </div>
    </div>
    <div class="illustrate">
      <div class="illustrate_title">10维技术引擎联动，从全栈开发到虚实共生</div>
      <div class="illustrate_bottom">
        <div class="illustrate_bottom_left">
          <div
            class="illustrate_bottom_left_one"
            @mouseover="changeIllustrate = 1"
            :style="
              changeIllustrate == 1
                ? 'background:#5D5BEF;color:#fff;'
                : 'background:#fff;color:#000;'
            "
          >
            <img src="" alt="" />
            数字技术类
          </div>
          <div
            class="illustrate_bottom_left_two"
            @mouseover="changeIllustrate = 2"
            :style="
              changeIllustrate == 2
                ? 'background:#5D5BEF;color:#fff;'
                : 'background:#fff;color:#000;'
            "
          >
            互动装置类
          </div>
          <div
            class="illustrate_bottom_left_three"
            @mouseover="changeIllustrate = 3"
            :style="
              changeIllustrate == 3
                ? 'background:#5D5BEF;color:#fff;'
                : 'background:#fff;color:#000;'
            "
          >
            价值观
          </div>
        </div>
        <div class="illustrate_bottom_right">
          <div
            class="illustrate_bottom_right_one"
            v-show="changeIllustrate == 1"
          >
            <p>
              <img src="@/statis/imgs/q1.png" alt="" />
              <span>AR</span>
              <span>移动端AR叠加场景信息，虚实叠加赋能场景实时交互。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q2.png" alt="" />
              <span>VR</span>
              <span>沉浸式头显系统，构建全感官虚拟现实世界。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q3.png" alt="" />
              <span>软件开发</span>
              <span>全栈开发生态，App/小程序/网页一站式数字基建。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q3.png" alt="" />
              <span>沉浸式</span>
              <span>全景投影造境，打造包裹式展览/演艺空间。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q12.png" alt="" />
              <span>数字人</span>
              <span>AI驱动数字分身，拟真形象提供智能导览服务。</span>
            </p>
          </div>
          <div
            class="illustrate_bottom_right_two"
            v-show="changeIllustrate == 2"
          >
            <p>
              <img src="@/statis/imgs/q4.png" alt="" />
              <span>互动装置</span>
              <span>机电装置融合数字内容，创造可玩性艺术载体。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q5.png" alt="" />
              <span>触屏互动</span>
              <span
                >多点触控终端，实现多场景下的人机交互效能与体验的协同优化。</span
              >
            </p>
            <p>
              <img src="@/statis/imgs/q6.png" alt="" />
              <span>体感互动</span>
              <span>肢体动作操控虚拟内容，打造无接触交互新体验。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q7.png" alt="" />
              <span>墙面互动</span>
              <span>手势操控墙幕，实现动态信息趣味化传递。</span>
            </p>
            <p>
              <img src="@/statis/imgs/q11.png" alt="" />
              <span>地面互动</span>
              <span>压力传感地屏，步态激活沉浸式场景响应系统。</span>
            </p>
          </div>
          <div
            class="illustrate_bottom_right_three"
            v-show="changeIllustrate == 3"
          >
            <p>
              <img src="@/statis/imgs/q8.png" alt="" />
              <span>我们的目标</span>
              <span>让数字艺术色彩融入生活点滴，提升生活品质</span>
            </p>
            <p>
              <img src="@/statis/imgs/q9.png" alt="" />
              <span>我们的使命</span>
              <span>专注做好每一个项目的执行</span>
            </p>
            <p>
              <img src="@/statis/imgs/q10.png" alt="" />
              <span>我们的愿景</span>
              <span>成为卓越的数字视觉创意服务商。</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Solution></Solution>
    <CoreStrengths></CoreStrengths>
    <Example></Example>
    <Partners></Partners>
  </div>
</template>

<script>
import Solution from "@/components/Solution";
import CoreStrengths from "@/components/CoreStrengths";
import Example from "@/components/Example";
import Partners from "@/components/Partners";

// import TopBar from "@/components/TopBar"
export default {
  data() {
    return {
      bannerListHeight: "100vh",
      changeIllustrate: 1,
      // topBar: 0,
      isMobile: 0,
    };
  },
  components: {
    Solution,
    CoreStrengths,
    Example,
    Partners,
  },
  created() {
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);

    this.handleResize();
  },
  mounted() {
    // console.log("首页");
    // let that = this;
    // window.onscroll = function () {
    //   //为了保证兼容性，这里取两个值，哪个有值取哪一个
    //   //scrollTop就是触发滚轮事件时滚轮的高度
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   if (scrollTop == 0) {
    //     that.topBar = 0;
    //   } else {
    //     that.topBar = 1;
    //   }
    // };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      console.log(document.body.clientWidth);

      if (document.body.clientWidth > 550) {
        this.isMobile = 0;
      } else {
        this.isMobile = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/statis/css/base.less";
.home {
  .topBar {
    width: 100%;
    height: 70px;
    position: fixed;
    top: 0;
    z-index: 999;
    background: rgba(85, 84, 84, 0.304);
    z-index: 9999;
    transition: all 0.3s;
    border-bottom: 2px solid rgba(162, 158, 158, 0.162);

    &_left {
      position: absolute;
      left: 20%;
      top: 20%;
    }
    &_right {
      width: 700px;
      height: 100%;
      position: absolute;
      right: 20%;
      .fixcenter();

      p {
        width: 15%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        cursor: default;
      }

      .transitionBar {
        width: 100px;
        height: 5px;
        background: #fff;
        position: absolute;
        bottom: 5px;
        left: 196px;
        border-radius: 1vw;
      }
    }
  }
  .bannerList {
    width: 100%;
    height: 100vh;
    position: relative;

    &_title {
      position: absolute;
      width: 50%;
      height: 80px;
      top: calc(50vh - 40px);
      left: calc(25%);
      z-index: 999;
      color: #fff;
      .fixcenter();
      font-weight: bold;
      font-size: 3vw;
    }

    video {
      width: 100%;
      height: 100%;
      transform: scale(1.2);
    }
  }

  .illustrate {
    width: 100%;
    height: 55vw;
    background: #fafcff;

    &_title {
      width: 100%;
      height: 20%;
      max-height: 250px;
      .fixcenter();
      font-size: 36px;
      font-weight: 400;
      color: #000;
    }

    &_bottom {
      width: 100%;
      max-width: 1600px;
      max-height: 800px;
      height: 70%;
      .fixcenter();
      margin: auto;

      &_left {
        width: 20%;
        height: 100%;

        &_one,
        &_two,
        &_three {
          width: 80%;
          height: 17%;
          background: #fff;
          margin: 40px auto;
          box-shadow: 0px 8px 8px 0px rgb(230 233 240 / 50%);
          transition: all 0.3s;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1vw;
          color: #000;
          border-radius: 0.3vw;

          &:hover {
            transform: translateY(-20px);
            background: #5d5bef;
            color: #fff;
          }
        }
      }

      &_right {
        width: 80%;
        height: 100%;

        &_one,
        &_two,
        &_three {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          p {
            width: 30%;
            height: 45%;
            background: #fff;
            box-shadow: 0px 8px 8px 0px rgb(230 233 240 / 50%);
            margin-top: 40px;
            transition: all 0.3s;
            cursor: pointer;
            margin-left: 20px;
            position: relative;

            img {
              width: 15%;
              height: 17%;
              position: absolute;
              left: 10%;
              top: 10%;
            }

            span {
              display: block;
              width: 85%;
              height: 13%;
              margin: auto;

              &:nth-child(2) {
                margin-top: 30%;
                text-align: left;
                font-size: 1vw;
              }
              &:nth-child(3) {
                text-align: left;
                color: rgb(140, 138, 138);
                line-height: 1.2vw;
              }
            }

            &:hover {
              transform: translateY(-20px);
            }
          }
        }
      }
    }
  }
}

.el-carousel__item {
  //&:nth-child(1) {
  //  width: 100%;
  //  height: 100%;
  //  background: url("https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/index01.gif")
  //    no-repeat center;
  //  background-size: 100%;
  //}
}

@media (max-width: 1920px) {
  .home {
    .illustrate {
      height: 65vw;

      &_bottom {
        &_left {
          &_one,
          &_two,
          &_three {
            font-size: 1.3vw;
          }
        }

        &_right {
          &_one,
          &_two,
          &_three {
            p {
              span {
                &:nth-child(2) {
                  font-size: 1.3vw;
                }
                &:nth-child(3) {
                  line-height: 1.7vw;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 550px) {
  .home {
    .bannerList {
      height: 100vh;
      overflow: hidden;
      .el-carousel__item {
        //&:nth-child(1) {
        //  width: 100%;
        //  height: 100%;
        //  background: url("https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/index01.gif")
        //    no-repeat center;
        //  background-size: 400%;
        //  background-position-y: 50%;
        //}
      }

      &_title {
        font-size: 5vw !important;
      }
    }

    .illustrate {
      height: auto;

      &_title {
        font-size: 6vw;
        padding: 15vw 17vw;
        box-sizing: border-box;
        font-weight: bold;
        width: 100%;
        height: 24vw;
      }

      &_bottom {
        display: flex;
        flex-direction: column;
        height: auto;
        overflow: hidden;

        &_right {
          width: 100%;
          height: auto;
          overflow: scroll;

          &_one,
          &_two,
          &_three {
            width: 400vw;
            height: auto;
            overflow-x: scroll;
            display: block;

            p {
              width: 72vw;
              height: 70vw;
              display: block;
              float: left;
              margin-bottom: 4vw;

              span {
                &:nth-child(2) {
                  font-size: 4.5vw;
                }

                &:nth-child(3) {
                  line-height: 7vw;
                  font-size: 3.5vw;
                  overflow: hidden;
                  height: 40%;
                }
              }
            }
          }
        }

        &_left {
          width: 100%;
          height: 20vw;
          display: flex;
          justify-content: center;
          align-items: center;

          &_one,
          &_two,
          &_three {
            height: 10vw;
            font-size: 3.5vw;
          }
        }
      }
    }
  }
}
</style>
